/** @jsxImportSource @emotion/react */

import { Button, Checkbox } from "antd";
import DatePickerCustom from "components/common/DatePickerCustom";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUsername } from "store/auth";
import {
  resetBettingRecord,
  selectIsLoadingBettingRecord,
  selectPageBettingRecord,
} from "store/bettingrecord";
import { getWager } from "store/bettingrecord/bettingrecord.thunk";
import { AppDispatch } from "types";

import { FormHistoryMobileStyle } from "./style.index";

interface State {
  startDate: Dayjs;
  endDate: Dayjs;
}

const PAGE_SIZE = 10;

const FromHistoryMobile = () => {
  const dispatch = useDispatch<AppDispatch>();

  const pageBettingRecord = useSelector(selectPageBettingRecord);
  const isLoadingBettingRecord = useSelector(selectIsLoadingBettingRecord);
  const _username =
    useSelector(selectUsername) || localStorage.getItem("username") || "";

  const [state, setState] = useState<State>({
    startDate: dayjs().subtract(7, "days"),
    endDate: dayjs(),
  });

  const isDisable =
    dayjs(state.startDate, "YYYY-MM-DD").isValid() &&
    dayjs(state.startDate, "YYYY-MM-DD").isValid() &&
    !isLoadingBettingRecord;

  useEffect(() => {
    dispatch(
      getWager({
        username: _username,
        page: pageBettingRecord,
        size: PAGE_SIZE,
        start: state.startDate.format("YYYY-MM-DD").toString(),
        end: state.endDate.format("YYYY-MM-DD").toString(),
      }),
    );
  }, [pageBettingRecord]);

  const getDataWager = () => {
    dispatch(resetBettingRecord());
    dispatch(
      getWager({
        username: _username,
        page: pageBettingRecord,
        size: PAGE_SIZE,
        start: state.startDate.format("YYYY-MM-DD").toString(),
        end: state.endDate.format("YYYY-MM-DD").toString(),
      }),
    );
  };

  return (
    <div css={FormHistoryMobileStyle.wrapper}>
      <h4>Thời gian đặt cược</h4>
      <div css={FormHistoryMobileStyle.inputGroup}>
        <DatePickerCustom
          defaultValue={state.startDate}
          format={"MMM D, YYYY"}
          onChange={(val) => {
            setState((prev) => ({
              ...prev,
              startDate: dayjs(val),
            }));
          }}
          disabledDate={(current) => {
            return current > dayjs().endOf("day");
          }}
          suffixIcon={<></>}
        />
        -
        <DatePickerCustom
          defaultValue={state.endDate}
          format={"MMM D, YYYY"}
          disabledDate={(current) => {
            return current > dayjs().endOf("day");
          }}
          onChange={(val) => {
            setState((prev) => ({
              ...prev,
              endDate: dayjs(val),
            }));
          }}
          suffixIcon={<></>}
        />
      </div>
      <div css={FormHistoryMobileStyle.selectGroup}>
        <label htmlFor="">Loại trò chơi</label>
        <select>
          <option> Không có dữ liệu gần đây </option>
        </select>
      </div>
      <div css={FormHistoryMobileStyle.checkBoxGroup}>
        <Checkbox />
        <p>Chỉ tìm kiếm đơn cược chưa thanh toán</p>
      </div>
      <div css={FormHistoryMobileStyle.btnGroup}>
        <Button type="primary" disabled={!isDisable} onClick={getDataWager}>
          <span>Tìm kiếm</span>
        </Button>
      </div>
    </div>
  );
};

export default FromHistoryMobile;
